import { Organization } from '@/types'
import { Link, router } from '@inertiajs/react'
import { Anchor, Breadcrumbs, Button, Group, Paper, Stack, TextInput, Title } from '@mantine/core'
import { useForm } from '@mantine/form'
import { IconArrowLeft } from '@tabler/icons-react'

interface OrganizationFormProps {
  organization?: Organization
}

export default function OrganizationForm({ organization }: OrganizationFormProps) {
  const isEditing = !!organization

  const form = useForm({
    initialValues: {
      name: organization?.name || '',
    },
  })

  const handleSubmit = (values: typeof form.values) => {
    if (isEditing) {
      router.put(`/organizations/${organization.slug}`, { organization: values })
    } else {
      router.post('/organizations', { organization: values })
    }
  }

  const breadcrumbItems = [
    { title: 'Organisations', href: '/organizations' },
    { title: isEditing ? `Modifier ${organization.name}` : 'Nouvelle organisation', href: '#' },
  ].map((item, index) => (
    <Anchor component={Link} href={item.href} key={index} size="sm">
      {item.title}
    </Anchor>
  ))

  return (
    <Stack gap="xl" maw={600} mx="auto">
      <Stack gap="xs" ta="center">
        <Group justify="center">
          <Breadcrumbs>{breadcrumbItems}</Breadcrumbs>
        </Group>
        <Title>{isEditing ? "Modifier l'Organisation" : 'Nouvelle Organisation'}</Title>
      </Stack>

      <Paper withBorder radius="md" p="xl">
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <Stack gap="lg">
            <TextInput
              label="Nom de l'organisation"
              placeholder="Ex: Lacoste Paris"
              required
              size="md"
              {...form.getInputProps('name')}
            />

            <Group justify="flex-end" mt="xl">
              <Button
                variant="subtle"
                color="gray"
                component={Link}
                href="/organizations"
                leftSection={<IconArrowLeft size={16} />}
              >
                Annuler
              </Button>
              <Button type="submit" size="md" px="xl">
                {isEditing ? 'Enregistrer les modifications' : "Créer l'organisation"}
              </Button>
            </Group>
          </Stack>
        </form>
      </Paper>
    </Stack>
  )
}
